export const styles = {
  calendarContainer: {
    position: "relative",
    width: "auto",
    border: "1px solid #D1D9EF",
    borderRadius: 2,
    padding: "3.5px",
    "&:hover": {
      borderColor: "#666",
    },
  },
  footer: {
    my: 3,
    display: "flex",
    gap: 1,
    position: { xs: "initial", md: "absolute" },
    right: 24,
    bottom: 0,
  },
};
